import React from 'react';

const LogoNavSVG = ({
  className = '',
  color,
  innerColor = null,
  opacity,
  width = 22,
  height = 25,
}) => (
  <svg className={className} width={width} height={height} viewBox="0 0 18 21">
    <defs>
      <rect id="path-1" x="0" y="0" width="18" height="22" />
    </defs>
    <g
      id="webpage"
      stroke="none"
      strokeWidth="1"
      fill={color}
      fillRule="evenodd"
    >
      <g id="Combined-Shape-Copy-4">
        <mask fill={color}>
          <use href="#path-1" />
        </mask>
        <g id="Mask" />
        <path
          d="M8.99172345,11.0299036 C8.84516646,11.6272005 8.48957564,12.1337877 8.01571602,12.3984811 L7.64893751,12.6032831 L8.31772552,13.7579861 L8.66945519,13.5604613 C9.17093554,13.2790257 9.59613895,12.8434316 9.89903367,12.3009069 C10.2047316,11.7531841 10.3721868,11.117689 10.3832521,10.4634811 L10.3833997,10.4565009 L10.3832521,10.4493722 C10.3721868,9.79516429 10.2047316,9.15981775 9.89903367,8.61209498 C9.59613895,8.06957023 9.17093554,7.63397617 8.66945519,7.35239201 L8.31772552,7.15486726 L7.64893751,8.30957023 L8.01571602,8.51437221 C8.50524047,8.78781585 8.86854742,9.31941064 9.00556948,9.94247788 L4.62733967,9.94247788 C4.42765836,9.55631749 4.02623874,9.2920354 3.56464848,9.2920354 C2.90456519,9.2920354 2.36752828,9.83248094 2.36752828,10.4969364 C2.36752828,11.1613918 2.90456519,11.7019859 3.56464848,11.7019859 C4.03476436,11.7019859 4.44246636,11.4277757 4.63819671,11.0299036 L8.99172345,11.0299036 Z M8.70471924,21 C3.89723555,21 -3.55271368e-15,16.2989899 -3.55271368e-15,10.5 C-3.55271368e-15,4.70101013 3.89723555,0 8.70471924,0 C13.5122029,0 17.4094385,4.70101013 17.4094385,10.5 C17.4094385,16.2989899 13.5122029,21 8.70471924,21 Z M13.4979109,11.2317182 C13.2494575,13.7037479 11.8975704,15.7863717 10.0164658,16.8109756 L10.7277446,18.0085994 C13.1672791,16.6728568 14.8683878,13.8372628 14.9254848,10.5374113 C14.8683878,7.23785683 13.1672791,4.40226277 10.7277446,3.06637168 L10.0164658,4.26399544 C11.8975704,5.2885994 13.24931,7.37137168 13.4979109,9.84325287 L13.5173858,10.5374113 L13.4979109,11.2317182 Z M9.50945669,15.9004219 L9.67617419,15.8068575 C10.5289416,15.3280456 11.2542365,14.5833922 11.7731263,13.6536892 C12.303229,12.7040853 12.593583,11.6006199 12.6127629,10.4624021 L12.6129104,10.4589862 L12.6127629,10.4557189 C12.593583,9.3175011 12.303229,8.21403575 11.7731263,7.26443179 C11.2542365,6.33472882 10.5289416,5.59007535 9.67617419,5.11126347 L9.50945669,5.01769912 L8.83270165,6.18621397 L9.00635342,6.28319416 C9.6075692,6.61898624 10.1328031,7.13373872 10.5255482,7.77205555 C10.9262604,8.42329317 11.1798776,9.19007535 11.2594003,9.99042189 L11.2722361,10.4589862 L11.2594003,10.9276991 C11.1798776,11.7278971 10.9262604,12.4948278 10.5255482,13.1460655 C10.1329506,13.7842338 9.6075692,14.2991348 9.00635342,14.6347783 L8.83270165,14.731907 L9.50945669,15.9004219 Z"
          fill={color}
        />
      </g>
    </g>
  </svg>
);

export default LogoNavSVG;
